
import { Options, Vue } from "vue-class-component";

@Options({
  props: {
    metric: Object,
    href: String,
  },
})
export default class MetricSource extends Vue {
  handleClick() {
    this.$emit("handleClick", null);
  }
}
